export default __webpack_public_path__ + "static/media/hero-one.4c8812bd.jpg";